<template>
  <div class="row dados-meio-pagamento" :class="{ 'no-label': removerLabels }">
    <div class="col-md-2" v-if="parcelado">
      <ValidationProvider rules="required" :name="`parcela${_uid}`">
        <b-form-group label="Parcela" slot-scope="{ valid, errors }">
          <b-input-group size="md" append="X">
            <b-form-input
              :disabled="readOnly"
              type="number"
              :min="minMax.min"
              :max="minMax.max"
              :step="1"
              :name="`parcela${_uid}`"
              placeholder="Parcela"
              v-model.number="item.installmentFrom"
              :state="errors[0] ? false : valid ? true : null"
              @change="$emit('changeInstallment', index)"
            />
          </b-input-group>
          <b-form-invalid-feedback>
            {{ errors[0] }}
          </b-form-invalid-feedback>
        </b-form-group>
      </ValidationProvider>
    </div>

    <div class="col-md-2">
      <ValidationProvider rules="required|min:0.1" :name="`imposto${_uid}`">
        <b-form-group label="Imposto" slot-scope="{ valid, errors }">
          <b-input-group size="md" append="%">
            <b-form-input
              :disabled="readOnly"
              type="number"
              placeholder="Imposto "
              :min="0"
              :step="0.01"
              :name="`imposto${_uid}`"
              :state="errors[0] ? false : valid ? true : null"
              v-model.number="item.tax"
            />
          </b-input-group>
          <b-form-invalid-feedback>
            {{ errors[0] }}
          </b-form-invalid-feedback>
        </b-form-group>
      </ValidationProvider>
    </div>

    <div class="col-md-2">
      <ValidationProvider rules="required|min:0.01" :name="`taxa${_uid}`">
        <b-form-group label="Taxa" slot-scope="{ valid, errors }">
          <b-input-group size="md" append="%">
            <b-form-input
              :disabled="readOnly"
              type="number"
              placeholder="Taxa"
              :min="0.01"
              :step="0.01"
              :name="`taxa${_uid}`"
              v-model.number="item.merchantFee"
              :state="errors[0] ? false : valid ? true : null"
            />
          </b-input-group>
          <b-form-invalid-feedback>
            {{ errors[0] }}
          </b-form-invalid-feedback>
        </b-form-group>
      </ValidationProvider>
    </div>

    <div class="col-md-2">
      <ValidationProvider rules="required|min:0.1" :name="`plataforma${_uid}`">
        <b-form-group label="Plataforma" slot-scope="{ valid, errors }">
          <b-input-group size="md" append="%">
            <b-form-input
              disabled
              type="number"
              :name="`plataforma${_uid}`"
              placeholder="Plataforma"
              :min="15"
              readonly
              :step="0.01"
              v-model.number="item.platformComission"
              :state="errors[0] ? false : valid ? true : null"
            />
          </b-input-group>
          <b-form-invalid-feedback>
            {{ errors[0] }}
          </b-form-invalid-feedback>
        </b-form-group>
      </ValidationProvider>
    </div>

    <div class="col-md-2">
      <ValidationProvider rules="required|min:0.1" :name="`comissao${_uid}`">
        <b-form-group label="Comissão" slot-scope="{ valid, errors }">
          <b-input-group size="md" append="%">
            <b-form-input
              :disabled="readOnly"
              type="number"
              placeholder="Comissão"
              :name="`comissao${_uid}`"
              :min="0"
              :step="0.01"
              v-model.number="item.salesmanComission"
              :state="errors[0] ? false : valid ? true : null"
            />
          </b-input-group>
          <b-form-invalid-feedback>
            {{ errors[0] }}
          </b-form-invalid-feedback>
        </b-form-group>
      </ValidationProvider>
    </div>

    <div class="col-md-1 coluna-dias-disponiveis">
      <ValidationProvider rules="required|min:0" :name="`comissao${_uid}`">
        <b-form-group label="Dias Disponível" slot-scope="{ valid, errors }">
          <b-form-input
            :disabled="readOnly"
            type="number"
            :min="0"
            :step="1"
            :name="`diasdisponiveis${_uid}`"
            placeholder="Dias Disponível"
            v-model.number="item.availableDays"
            :state="errors[0] ? false : valid ? true : null"
          />
          <b-form-invalid-feedback>
            {{ errors[0] }}
          </b-form-invalid-feedback>
        </b-form-group>
      </ValidationProvider>
    </div>
    <div class="col-md-1 item-center" v-if="parcelado">
      <template v-if="!readOnly">
        <b-form-group label=" ">
          <a-tooltip placement="top">
            <template slot="title">
              <span>Remover Parcela</span>
            </template>
            <a
              href="javascript: void(0);"
              @click="remover"
              class="btn btn-sm btn-light"
            >
              <i class="fe fe-trash" />
            </a>
          </a-tooltip>
        </b-form-group>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "DadosMeioPagamento",
  props: {
    item: {
      type: Object,
      default: () => null
    },
    index: {
      type: Number,
      default: () => 0
    },
    parcelado: {
      type: Boolean,
      default: () => false
    },
    removerLabels: {
      type: Boolean,
      default: () => false
    },
    minMaxInstallment: {
      type: Object,
      default: () => {
        return { min: 2, max: 15 };
      }
    },
    readOnly: {
      type: Boolean,
      default: () => false
    }
  },
  computed: {
    minMax() {
      return this.minMaxInstallment;
    }
  },
  methods: {
    remover() {
      this.$emit("remover", this.index);
    }
  },
  created() {}
};
</script>
<style lang="scss" scoped>

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
     -webkit-appearance: none; 
     margin: 0;
  }
  input[type="number"] {
     -moz-appearance: textfield;
  }

.dados-meio-pagamento {
  /deep/ {
    .ant-input-number {
      width: 100%;
    }
    .ant-form-item-control {
      min-height: 30px;
      position: relative;
    }
    .ant-form-item-label {
      min-height: 37.5px;
    }
  }
  &.no-label {
    /deep/ {
      legend {
        display: none;
      }
    }
  }
}
.coluna-dias-disponiveis {
  /deep/ {
    legend {
      white-space: nowrap;
    }
  }
}
</style>
